import { useAuth } from '../contexts/AuthContext';

/**
 * 사용자 역할 관련 훅
 */
export const useUserRole = () => {
  const { user } = useAuth();

  const isRentalManagementCompany = user?.role === 'rental_management_company' || 
                                   user?.role === 'rmc_admin' || 
                                   user?.role === 'rmc_staff';
  const isPropertyOwner = user?.role === 'property_owner';
  const isSuperAdmin = user?.role === 'super_admin';

  return {
    user,
    isRentalManagementCompany,
    isPropertyOwner,
    isSuperAdmin,
    role: user?.role
  };
};
